/**
 * Created by Abner Sui on 12/1/2020
 * -------------------------------------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { WidgetsModule } from '../../widgets/widgets.module';
import { TemplateConfigurationComponent } from './template-configuration.component';
import { ControlShellComponent } from './control-shell.component';
import { SectionShellComponent } from './section-shell.component';
import { TextFieldComponent } from '../work-flow/field/text-field.component';
import { FieldModule } from '../work-flow/field/field.module';
import { SingleTextDropdownFieldComponent } from '../work-flow/field/single-text-dropdown-field.component';
import { SingleEntityDropdownFieldComponent } from '../work-flow/field/single-entity-dropdown-field.component';
import { NumberFieldComponent } from '../work-flow/field/number-field.component';
import { FileFieldComponent } from '../work-flow/field/file-field.component';
import { NumberConfigComponent } from '../work-flow/field/number-config.component';
import { TextConfigComponent } from '../work-flow/field/text-config.component';
import { SingleEntityDropdownConfigComponent } from '../work-flow/field/single-entity-dropdown-config.component';
import { SingleTextDropdownConfigComponent } from '../work-flow/field/single-text-dropdown-config.component';
import { FileConfigComponent } from '../work-flow/field/file-config.component';
import { DateConfigComponent } from '../work-flow/field/date-config.component';
import { DateFieldComponent } from '../work-flow/field/date-field.component';
import { TextAreaFieldComponent } from './../work-flow/field/text-area-field.component';
import { TextAreaConfigComponent } from '../work-flow/field/text-area-config.component';
import { RichEditorConfigComponent } from '../work-flow/field/rich-editor-config.component';
import { RichEditorFieldComponent } from './../work-flow/field/rich-editor-field.component';
import { EntityDropdownConfigComponent } from '../work-flow/field/entity-dropdown-config.component';
import { EntityFieldComponent } from '../work-flow/field/entity-field.component';
import { CheckListConfigComponent } from '../work-flow/field/check-list-config/check-list-config.component';
import { CheckListFieldComponent } from '../work-flow/field/check-list-field/check-list-field.component';
import { SingleUserDropdownConfigComponent } from '../work-flow/field/single-user-dropdown-config/single-user-dropdown-config.component';
import { SingleUserDropdownFieldComponent } from '../work-flow/field/single-user-dropdown-field/single-user-dropdown-field.component';

@NgModule({
    imports: [
        CommonModule,
        // kendo
        TooltipModule,
        // project
        WidgetsModule,
        FieldModule,
    ],
    declarations: [
        TemplateConfigurationComponent,
        ControlShellComponent,
        SectionShellComponent,
    ],
    exports: [
        TemplateConfigurationComponent,
    ],
    providers: []
})
export class TemplateConfigurationModule { }
